import React, { useEffect, useState } from 'react';
import { LockIcon, AlertCircleIcon } from 'lucide-react';
interface PasswordProtectionProps {
  onUnlock: () => void;
}
export const PasswordProtection = ({
  onUnlock
}: PasswordProtectionProps) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [attemptCount, setAttemptCount] = useState(0);
  const [isLocked, setIsLocked] = useState(false);
  const [lockoutTimer, setLockoutTimer] = useState(0);
  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (isLocked && lockoutTimer > 0) {
      interval = setInterval(() => {
        setLockoutTimer(prev => prev - 1);
      }, 1000);
    } else if (lockoutTimer === 0) {
      setIsLocked(false);
    }
    return () => clearInterval(interval);
  }, [isLocked, lockoutTimer]);
  const handleSubmit = () => {
    if (isLocked) return;
    // Komplexeres Passwort: Kombination aus Zahlen
    if (password === '22348765') {
      onUnlock();
      // Reset security state
      setAttemptCount(0);
      setError(false);
    } else {
      const newAttemptCount = attemptCount + 1;
      setAttemptCount(newAttemptCount);
      setError(true);
      setPassword('');
      // Nach 3 fehlgeschlagenen Versuchen: 30 Sekunden Sperre
      if (newAttemptCount >= 3) {
        setIsLocked(true);
        setLockoutTimer(30);
        setAttemptCount(0);
      }
    }
  };
  return <div className="flex flex-col items-center justify-center h-full p-6 bg-white" data-id="element-55">
      <div className="w-16 h-16 rounded-full bg-[#e76405] bg-opacity-10 flex items-center justify-center mb-6" data-id="element-56">
        <LockIcon size={32} className="text-[#e76405]" data-id="element-57" />
      </div>
      <h1 className="text-2xl font-bold mb-2" data-id="element-58">Production Scanner</h1>
      <p className="text-sm text-gray-500 mb-6 text-center" data-id="element-59">
        Bitte geben Sie Ihr Passwort ein, um fortzufahren
      </p>
      <div className="w-full max-w-xs" data-id="element-60">
        {isLocked ? <div className="bg-red-50 p-4 rounded-lg mb-4" data-id="element-61">
            <div className="flex items-center gap-2 text-red-600 mb-2" data-id="element-62">
              <AlertCircleIcon size={20} data-id="element-63" />
              <span className="font-medium" data-id="element-64">Zugang gesperrt</span>
            </div>
            <p className="text-sm text-red-600" data-id="element-65">
              Zu viele falsche Versuche. Bitte warten Sie {lockoutTimer}{' '}
              Sekunden.
            </p>
          </div> : <>
            <input type="password" value={password} onChange={e => {
          setPassword(e.target.value.replace(/[^0-9]/g, ''));
          setError(false);
        }} maxLength={8} className={`w-full text-center text-2xl tracking-widest py-3 px-4 border-2 rounded-lg mb-4 ${error ? 'border-red-500' : 'border-gray-300'}`} placeholder="••••••••" autoFocus data-id="element-66" />
            {error && <div className="flex items-center gap-2 text-red-500 text-sm justify-center mb-4" data-id="element-67">
                <AlertCircleIcon size={16} data-id="element-68" />
                <span data-id="element-69">
                  Falsches Passwort
                  {attemptCount > 0 && ` (${3 - attemptCount} Versuche übrig)`}
                </span>
              </div>}
            <button onClick={handleSubmit} disabled={password.length !== 8} className={`w-full py-3 px-4 rounded-lg font-medium ${password.length === 8 ? 'bg-[#e76405] text-white hover:bg-[#d55a00]' : 'bg-gray-200 text-gray-400 cursor-not-allowed'} transition-colors`} data-id="element-70">
              Entsperren
            </button>
          </>}
      </div>
    </div>;
};